export default "precision highp float;\nvoid main() {\n  // Only the depth attachment is written in this pass.\n}\n"